/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { UserInfo, useUserInfoLazyQuery } from '../../../../../graphql/generated/graphql';

import DashboardNavbar from '../common/navbar';
import DashboardSidebar from './sidebar';
import { setUserInfo } from '../../../../hooks/userInfo';

const DashboardLayoutRoot = styled('section')(({ theme }) => ({
  minWidth: '100vw',
  minHeight: '100vh',
  paddingTop: 70,
  [theme.breakpoints.up('md')]: {
    paddingLeft: 280,
  },
}));

const ConfigProjectLayout = (props: any) => {
  const { children } = props;
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [userInfo, { data }] = useUserInfoLazyQuery();

  useEffect(() => {
    userInfo();
  }, []);

  useEffect(() => {
    if (data) {
      setUserInfo(data.userInfo as UserInfo);
    }
  }, [data]);

  return (
    <>
      {data && (
        <DashboardLayoutRoot>
          <DashboardNavbar onSidebarOpen={() => setSidebarOpen(true)} />
          <DashboardSidebar
            onClose={() => setSidebarOpen(false)}
            open={isSidebarOpen}
          />
          <Box
            sx={{
              width: '100%',
              p: 4,
            }}
          >
            {children}
          </Box>
        </DashboardLayoutRoot>
      )}
    </>
  );
};

export default ConfigProjectLayout;
